import { render, staticRenderFns } from "./BusinessNameDataUpdateMessages.vue?vue&type=template&id=a7988d52&scoped=true&"
import script from "./BusinessNameDataUpdateMessages.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7988d52",
  null
  
)

export default component.exports